import { type MessageDataType, type IRoomSendMessageResult, Command } from '@tencent/docs-connection';
import { ErrorSource, WaitAcceptCmd } from '../constants';
import { SubmitHandler } from './submit-handler';
import type { IRevisionHandler } from '../types';

export class SubmitAcceptHandler extends SubmitHandler {
    protected errorSource = ErrorSource.Server;

    public constructor(submitHandler: IRevisionHandler, moduleName: string) {
        super(submitHandler, moduleName);
    }
    /**
     * 3rd step：服务器接受到change的处理
     * 成功/失败
     */
    public onSubmitAccept = (
        taskId: number,
        cmd: string,
        data: MessageDataType,
        waitCmd: string | undefined,
        result: IRoomSendMessageResult,
    ) => {
        if (cmd === Command.USER_CHANGES) {
            switch (waitCmd) {
                case WaitAcceptCmd.AcceptCommit:
                    this.handleAcceptCommit(taskId, cmd, result);
                    break;
                case WaitAcceptCmd.CommitError:
                    this.handleCommitError(taskId, result);
                    break;
                default:
                    this.handleCommitError(taskId, result);
                    break;
            }
        }
    };

    /**
     * succeeded on 3rd step：服务器接受到change后的通知处理
     */
    private handleAcceptCommit(taskId: number, cmd: string, result: IRoomSendMessageResult) {
        if (result.errCode === 0 && result.response) {
            const newRev = result.response.new_rev; // 提交成功后返回的新版本
            const revisionData = result.response.body.data.changeset; // 提交成功后返回的新版本
            this.acceptCommit(taskId, newRev, revisionData);
            return;
        }
        this.handleCommitError(taskId, result);
    }

    /**
     * 服务器接收提交的change
     */
    private acceptCommit(taskId: number, newRev: number, revisionData: string) {
        const baseRev = this.submitHandler.getSubmittingUserChange()?.revision ?? -1;
        this.submitHandler.updateRetrySubmitCount(0);
        // 通知成功
        this.submitHandler.commitSuccess(taskId, baseRev, newRev, revisionData);
    }

    /**
     * 服务端成功收到提交的change，但是处理失败
     * @param taskId
     * @param cmd
     * @param result
     * @returns
     */
    private handleCommitError(taskId: number, result: IRoomSendMessageResult) {
        const errorCode = this.getErrorCode(result);
        const { msg = '' } = result?.response?.body?.data || {};
        this.submitHandler.logger.warn(
            this.moduleName,
            ` [${taskId}] maybe have some problems, reason: ${errorCode}, message: ${msg}`,
        );
        this.handleResponseError(taskId, result);
    }
}
